module.exports = __webpack_public_path__ + "870fbb7879719e8e5bfd9981439f85fb.pdf";